import { render, staticRenderFns } from "./VisionAuth.vue?vue&type=template&id=ba16d15a"
import script from "./VisionAuth.vue?vue&type=script&lang=ts"
export * from "./VisionAuth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports